<template>
  <div class="body-container text-center">
    <div class="signIn-container border-container align-items-center d-inline-grid">
      <div>
        <AuthVerifyEmail v-if="activeScreen == 'verifyEmail'" :lang="lang" :eventType="'password'" :buttonTitle="widget.translate('text_forgopswd', 'Reset Password')" :navTitle="this.widget.translate('FORGOT_PASSWORD_TITLE', 'Forgot Password')" @updateActiveScreen="updateActiveScreen"></AuthVerifyEmail>
        <AuthVerifyUsername v-if="activeScreen == 'verifyUsername'" :lang="lang" :eventType="'password'" :buttonTitle="widget.translate('text_forgopswd', 'Reset Password')" :navTitle="this.widget.translate('FORGOT_PASSWORD_TITLE', 'Forgot Password')" @updateActiveScreen="updateActiveScreen"></AuthVerifyUsername>
        <AuthOtp v-if="activeScreen == 'verifyOtp'" :lang="lang" :phoneFlag="selectedPhone" :eventType="'password'" :email="resetPassword.email" :title="widget.translate('pweb_title_verify_identity', 'Verify Identity')" @updateActiveScreen="updateActiveScreen"></AuthOtp>
        <Studies v-if="activeScreen == 'selectStudy'" :eventType="'password'" :lang="lang" :email="resetPassword.email" @updateActiveScreen="updateActiveScreen"></Studies>
        <Reset v-if="activeScreen == 'resetPassword' && isCognitoEnabled" :lang="lang" :data="resetPassword" :eventType="'password'" @updateActiveScreen="updateActiveScreen"></Reset>
      </div>
      <div v-if="legacyForgotMessage" class="consent-education-4 common-consent-edu">
        <div class="text-center">
          <img src="static/img/participant-portal/green-check-large.svg" alt="" class="edu-green-check" />
        </div>
        <p class="verify-name m-0">
          <span v-translate:verify_email="lang">Verification email was sent to</span>
          {{ email }}
        </p>
        <p class="pt-0 edu-consent-text " v-translate:ELIGIBLE_FOR_THE_STUDY_INFO_TEXT="lang">
          You are eligible to participate in this study. Tap the button below to be guided through the research activities and responsibilities.
        </p>
        <div class="text-center pt-12 ml-15 mr-15">
          <button class="btn btn-submit" v-translate:text_signin_button="lang">
            Next
          </button>
        </div>
      </div>
    </div>
    <Modal :show="showCancelModal" :title="widget.translate('ARE_YOU_SURE_TEXT', 'Are you sure?')" :helpText="widget.translate('pweb_help_text_cancel_forgot_password', 'You would like to cancel the Forgot Password process.')" :cancelButton="widget.translate('label_cancel', 'Cancel')" :okButton="widget.translate('label_ok', 'OK')" @modalCallback="modalCallback"></Modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AuthOtp from "@/components/participant-portal/auth/otp";
import AuthVerifyEmail from "@/components/participant-portal/auth/verify-email";
import AuthVerifyUsername from "@/components/participant-portal/auth/verify-username";
import Reset from "@/components/participant-portal/auth/forgot/reset";
import Studies from "@/components/participant-portal/auth/studies";
import Modal from "@/components/participant-portal/common/modal";
import { Widget, ParticipantPortal } from "@/components/services/participant-service";

export default {
  name: "auth-forgot-password",
  components: {
    AuthOtp,
    AuthVerifyEmail,
    AuthVerifyUsername,
    Reset,
    Studies,
    Modal
  },
  props: ["isOnCancelClick", "isOnBackClick", "forgotPassword", "globalElement", "isStudySelected"],
  data() {
    return {
      loading: false,
      isLoginSuccess: false,
      widget: new Widget(),
      selectedPhone: null,
      portal: new ParticipantPortal(),

      screens: [
        { name: "verifyEmail", isActive: true },
        { name: "verifyOtp", isActive: false },
        { name: "selectStudy", isActive: false },
        { name: "resetPassword", isActive: false }
      ],
      activeScreen: "verifyEmail",

      resetPassword: {
        otp: null,
        username: "",
        email: "",
        studyId: null,
        language: null,
        newPassword: null,
        cognitoEmail: null
      },
      pageTitle: null,
      showCancelModal: false,
      legacyForgotMessage: false
    };
  },
  mounted() {
    this.pageTitle = this.widget.translate("FORGOT_PASSWORD_TITLE", "Forgot Password");
    this.$emit("setHeaderOptions", {
      showBlankHeader: true,
      title: this.pageTitle,
      backRouterLink: "participants-portal-auth-login"
    });
  },
  watch: {
    globalElements(val) {
      this.lang = val.language ? val.language.language_culture : "en";
    },
    isOnBackClick(val) {
      if (val) {
        const activeIndex = this.screens.findIndex(e => e.isActive == true);
        if (activeIndex > 0 && activeIndex !== -1) {
          let newScreen = {};
          if (this.screens[activeIndex].name == "resetPassword") {
            newScreen = this.screens[activeIndex - 3];
          } else {
            newScreen = this.screens[activeIndex - 1];
          }
          this.activeScreen = this.isCognitoEnabled && newScreen.name == "verifyEmail" ? "verifyUsername" : newScreen.name;
          this.screens = this.screens.map(e => {
            e.isActive = e.name == newScreen.name;
            return e;
          });
        } else if (activeIndex === 0 && this.activeScreen === "verifyUsername") {
          this.$router.push("login");
        }
      }
    },
    isOnCancelClick() {
      this.showCancelModal = !this.showCancelModal;
    }
  },
  computed: {
    ...mapGetters(["participant", "token", "pwebCognitoAuthentication"]),
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    lang() {
      this.updateActiveScreenByLang();
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    },
    isCognitoEnabled() {
      return this.$store.getters.pwebCognitoAuthentication;
    }
  },
  methods: {
    updateActiveScreenByLang() {
      this.activeScreen = this.isCognitoEnabled ? "verifyUsername" : "verifyEmail";
    },
    modalCallback() {
      this.$router.push({ name: "participants-portal-auth-login" });
    },
    updateActiveScreen(keyOld) {
      let key = keyOld;
      if (key.verificationPhone === "phone") {
        this.selectedPhone = "phone";
      }
      if (typeof key === "object") {
        if (Object.keys(key).includes("flagChild")) {
          this[key.flagKey][key.flagChild] = key.flagValue;
        } else {
          this[key.flagKey] = key.flagValue;
        }
        key = key.key;
      }

      if (key !== "verifyEmail") {
        this.$emit("setHeaderOptions", {
          showBlankHeader: true,
          title: this.pageTitle
        });
      }

      this.screens = this.screens.map(e => {
        e.isActive = false;
        return e;
      });
      const newScreen = this.screens.find(e => e.name == key);
      if (newScreen) {
        this.activeScreen = newScreen.name;
        this.screens = this.screens.map(e => {
          e.isActive = e.name == key;
          return e;
        });
      }
    }
  }
};
</script>
